// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__wHovn","heroContent":"hero_heroContent__T23mL","logoText":"hero_logoText__tEZYP","caption":"hero_caption__SUZgy","logo":"hero_logo__gd9ii"};